import cookieUtil from "cookie";
import { i18n } from "app/i18n/i18n";
import preferencesConfig from "../data/preferences.json";

export const UI_LANG = "grp-ui-lang";
export const PUB_LANG = "grp-pub-lang";
export const TERMS_ACCEPTED = "grp-terms-accepted";
export const PAGE_SIZE = "grp-page-size";
export const VIEW = "grp-view";
export const DOMICILE = "grp-domicile";
export const BULLETIN = "grp-bulletin";
export const JAPI = "grp-japi";
export const PAGINATION_POS = "grp-pagination-pos";
export const BANNER_VISIBILITY = "grp-banner-visibility";

export const getPreferencesFromCookies = () => {
  const cookies = cookieUtil.parse(document.cookie);
  const initialPreferences = preferencesConfig.reduce((prefs, pref) => {
    const tempPrefs = prefs;
    tempPrefs[pref.id] = cookieOrDefaultValue(pref.id, pref.default, cookies);
    return tempPrefs;
  }, {});

  initialPreferences[UI_LANG] = getInitialLanguage();
  i18n.setLanguage(initialPreferences[UI_LANG][0]);
  return initialPreferences;
};

export const cookieOrDefaultValue = (cookieName, defaultValue, cookies) => {
  let tempCookies = cookies;
  if (!tempCookies) tempCookies = cookieUtil.parse(document.cookie);
  if (cookieName === BULLETIN) return tempCookies[cookieName] ? tempCookies[cookieName] : defaultValue;
  return tempCookies[cookieName] ? tempCookies[cookieName].split(",") : defaultValue;
};

const getInitialLanguage = () => cookieOrDefaultValue(UI_LANG, getDefaultLanguage());
const getDefaultLanguage = () => [getLangFromBrowserEnv() || "ja"];

const getLangFromBrowserEnv = () => {
  const lang = window.navigator.language.substr(0, 2);
  return ["en", "ja"].includes(lang) ? lang : null;
};
